import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Barcode from 'react-barcode';
import QRCode from 'react-qr-code';

import * as Styled from './styles';

function ExportCode({ data, unitName, typeCode }) {
  const displayTitle = (value) => {
    if (value.length > 65) return `${value.slice(0, 65)}...`;
    return value;
  };
  return typeCode === 'qr' ? (
    <Styled.GroupCode>
      {map(data,
        (codes, index) => (
          <div key={index} className={index ? 'page-break' : 'group-codes'}>
            {map(codes,
              ({ name, order }) => (
                <Styled.Code key={order}>
                  <Styled.GroupQRCode>
                    <Styled.TitleQRCode>
                      {name}
                      <div>{order || ''}</div>
                    </Styled.TitleQRCode>
                    <Styled.QR>
                      <QRCode size={70} value={order} />
                    </Styled.QR>
                  </Styled.GroupQRCode>
                </Styled.Code>
              ))}
          </div>
        ))}
    </Styled.GroupCode>
  ) : (
    <Styled.GroupCode>
      {map(data,
        (codes, index) => (
          <div key={index} className={index ? 'page-break' : 'group-codes'}>
            {map(codes,
              ({ name, order }) => (
                <Styled.Code key={order}>
                  <div style={{ width: '100%' }}>
                    <Styled.UnitName>
                      {unitName.toUpperCase()}
                    </Styled.UnitName>
                    <Styled.BC>
                      <Barcode fontSize={50} value={order} />
                    </Styled.BC>
                    <Styled.TitleBarcode>
                      {displayTitle(name)}
                    </Styled.TitleBarcode>
                  </div>
                </Styled.Code>
              ))}
            <Styled.NumberPage>{index + 1}</Styled.NumberPage>
          </div>
        ))}
    </Styled.GroupCode>
  );
}

ExportCode.propTypes = {
  unitName: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.shape()),
  ).isRequired,
  typeCode: PropTypes.string.isRequired,
};

export default ExportCode;
